import Req from '../../$axios';

const serviceModule = {
  // 获取用户信息
  getUserInfo(params) {
    return Req({
      url: '/user/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取验证码
  getVerificationCode(params) {
    return Req({
      url: '/common/getVerificationCode',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  resetPassword(params) {
    return Req({
      url: '/common/resetPassword',
      method: 'post',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
